import { config, Config, ENV } from './config';

export const getConfig = (): Config => {
	const env = getEnvironment();
	return config[env];
};

const getEnvironment = (): ENV => {
	const host = window.location.host;
	if (host.includes('dev') || host.includes('test1') || host.includes('stage1')) return 'tst';
	if (host.includes('test5')) return 'tst5';
	if (host.includes('new')) return 'stg';
	return 'prd';
};
